export const DEFAULT_BANK = {
  get_bank_list: null,
  get_bank_list_loading: false,
  verify_account_number: null,
  verify_account_number_loading: false,
  error: null
}
